var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsletterButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 43,
    fill: "#A5A5A5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1552_54)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1552_54)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1552_54",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1234 -1040.05H206V443.952H-1234V-1040.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-1234 -1040.05H206V443.952H-1234V-1040.05Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 546,
    transform: "translate(-1234 -102.048)",
    fill: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_1552_54",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1234 -102.048H206V315.952H-1234V-102.048Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206 314.952H-1234V316.952H206V314.952Z",
    fill: "#83858C",
    mask: "url(#path-3-inside-2_1552_54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 -3.04785H38C42.4183 -3.04785 46 0.53387 46 4.95215V38.9521C46 43.3704 42.4183 46.9521 38 46.9521H-4V-3.04785Z",
    fill: "#B4BAC2"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.952148,
    width: 42,
    height: 42,
    rx: 6,
    fill: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6235 12.7679L18.4545 12.613L18.2856 12.7679L15.8311 15.0179L15.63 15.2021L15.8311 15.3864L22.9937 21.9521L15.8311 28.5179L15.63 28.7021L15.8311 28.8864L18.2856 31.1364L18.4545 31.2913L18.6235 31.1364L28.4417 22.1364L28.6427 21.9521L28.4417 21.7679L18.6235 12.7679Z",
    fill: "#B4BAC2",
    stroke: "#B4BAC2",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205 -1040.05V443.952H207V-1040.05H205ZM-1233 443.952V-1040.05H-1235V443.952H-1233Z",
    fill: "#B4BAC2",
    mask: "url(#path-1-inside-1_1552_54)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1552_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1467,
    fill: "white",
    transform: "translate(-1234 -1104)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1552_54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1234 -1040.05H206V443.952H-1234V-1040.05Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletterButton);
export default __webpack_public_path__ + "static/media/newsletter-button.68ef95d07abe61c24638a7bb4b6ec5fe.svg";
export { ForwardRef as ReactComponent };